import { axiosInstance } from "@/api/apiClient";
import {
  AvailableNumberApi,
  AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";
import { CustomAxiosRequestConfig } from "../types";

const api = new AvailableNumberApi(undefined, BASE_API, axiosInstance);

export const getAvailableNumbers = async (
  payload: AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest
) => {
  return api.telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers.bind(
    api
  )(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};
